import { render, staticRenderFns } from "./SubmissionsCard.vue?vue&type=template&id=1e925f39&"
import script from "./SubmissionsCard.vue?vue&type=script&lang=js&"
export * from "./SubmissionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports